import React from 'react';
import * as Yup from 'yup';

import EditProfileFormSection from './EditProfileFormSection';
import TextInput from '@atoms/TextInput';
import SelectFunctionalTitles from '@molecules/SelectFunctionalTitles';
import SelectPersonalResponsibilities from '@molecules/SelectPersonalResponsibilities';
import { DividerLightGreyStyled, Instructions, LinkSmall } from '@styled';
import EditProfileFieldsBio, { editProfileBioValidationSchema } from '../../../_molecules/EditProfileFieldsBio';
import EditProfileFieldsEducation from '../../../_molecules/EditProfileFieldsEducation';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@tracking/TrackPageView';
import EditProfileTitle from '../../../_molecules/EditProfileTitle';
import useViewer from "@hooks/useViewer";

const EditProfileEduPage = () => {
    const { viewer } = useViewer();
    const isOfficial = viewer && viewer.official;
    const prevNavLink = '/my-icsc/account/edit-profile/contact';
    const prevNavLabel = 'Contact Information';
    const nextNavLink = isOfficial ? '/my-icsc/account/edit-company' : '/my-icsc/account/update-password';
    const nextNavLabel = isOfficial ? 'Edit Company Profile' : 'Update Password';

    return (
        <ErrorHandler>
            <TrackPageView>
                <EditProfileFormSection
                    pageTitleSub="Education & Employment"
                    prevNavLink={prevNavLink}
                    prevNavLabel={prevNavLabel}
                    nextNavLink={nextNavLink}
                    nextNavLabel={nextNavLabel}
                    validationSchema={{
                        ...editProfileBioValidationSchema,
                        title: Yup.string().required('Title is required.'),
                        personalResponsibility: Yup.string().required('Personal responsibility is required.'),
                    }}
                >
                    <DividerLightGreyStyled className="mt-3 mb-4"/>
                    <h4 className="mb-0">Education Information</h4>
                    <Instructions style={{marginBottom: '.5rem'}}>
                        Add your college and/or university information to expand your networking opportunities. This
                        information will be displayed on your member profile page.
                    </Instructions>
                    <EditProfileFieldsEducation/>

                    <DividerLightGreyStyled className="mt-5 mb-4"/>
                    <h4 className="mb-0">About Statement</h4>
                    <Instructions style={{marginBottom: 0}}>
                        Introduce yourself by adding a summary about your expertise and interests. Biographical
                        information
                        is displayed on your member profile page.
                    </Instructions>
                    <EditProfileFieldsBio label=""/>

                    <DividerLightGreyStyled className="mt-5 mb-4"/>
                    <h4 className="mb-0">Employment Information</h4>
                    <Instructions>
                        To edit your company, please email{' '}
                        <LinkSmall href="mailto:membership@icsc.com">membership@icsc.com</LinkSmall> a written
                        confirmation
                        of changes you'd like to make to your company. Accurate employment information helps you network
                        with other members and event attendees.
                    </Instructions>
                    <TextInput label="Company" name="companyName" disabled/>
                    <EditProfileTitle/>
                    <SelectFunctionalTitles/>
                    <SelectPersonalResponsibilities name="personalResponsibility" required/>
                </EditProfileFormSection>
            </TrackPageView>
        </ErrorHandler>
    );
};

export default EditProfileEduPage;
